import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { customStyles } from '../../../../HelperFunctions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import { adminMainUrl } from '../../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import { getAllApprovedCustomers, getCompanyBranch, getJobOrderEmployeeList, getUnusedQuotationByCompanyList, getUnusedQuotationByCustomerList } from '../../../../Redux/action/Joborder/JoborderAction';
const AddJobOrderByQuotationOffcanvas2 = ({
    token,
    user_id,
    quotation_id,
    show,
    handleClose,
    companyName,
    // branchOption,
    // setBranchOption,
    handleChangeCompanyBranch,
    disableQuotationField,
    // employeeOptions,
    disableTransportMode,
    disableTransportType,
    // quotationOption,
    loadingQuotation,
    trans_mode,
    trans_type,
    ChangeTransportMode,
    ChangeTransportType,
    company_id,
    disabledHasQuotation,
    resetCompanyName,
    // loadingJobOrderApprovedCustomerList,
    // JobOrderApprovedCustomerList,
    set_Branch_company_id,
    branch_company_id
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);

    const initialValues = {
        is_direct_customer: null,
        trans_mode: "",
        trans_type: "",
        quotation_id: "",
        customer_id: "",
        customer_branch_id: "",
        job_owner_id: "",
        has_quotation: true,
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // resetForm()
            // console.log(values);
            setDisableSubmit(true);
            if (!values.customer_branch_id) {
                values.customer_branch_id = null;
            }
            if (company_id) {
                values.customer_id = company_id
            }

            // console.log(values);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/jobOrder/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    const [customerOptions, setCustomerOptions] = useState([]);
    const [branchOption, setBranchOption] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [quotationOption, setQuotationOptions] = useState([]);

    useEffect(() => {
        dispatch(getAllApprovedCustomers(token, user_id));
        dispatch(getJobOrderEmployeeList(token, user_id));
    }, []);

    const {
        loadingJobOrderApprovedCustomerList,
        JobOrderApprovedCustomerList,
        JobOrderApprovedCustomerListError,

        loadingJobOrderCompanyBranchList,
        JobOrderCompanyBranchList,
        JobOrderCompanyBranchListError,


        loadingJobOrderEmployeeList,
        JobOrderEmployeeListError,
        JobOrderEmployeeList,


        loadingUnusedQuotationByCompanyList,
        UnusedQuotationByCompanyListError,
        UnusedQuotationByCompanyList,
    } = useSelector(state => state?.JoborderReducer);

    useEffect(() => {
        if (JobOrderApprovedCustomerList) {
            let arr = [];
            JobOrderApprovedCustomerList.map(v => { arr.push({ value: v.id, label: `${v.name} ${v.alias ? "( " + v.alias + " )" : ""} - ${v.customerType} ${v.entity ? "{" + v.entity + "}" : ""}`, parent_agent: v.parent_agent }) });
            setCustomerOptions(arr);
        }
    }, [JobOrderApprovedCustomerList]);

    useEffect(() => {
        if (JobOrderCompanyBranchList) {
            let arr = [];
            JobOrderCompanyBranchList.map(v => { arr.push({ value: v.id, label: v.branch_name }) });
            setBranchOption(arr);
        }
    }, [JobOrderCompanyBranchList]);

    useEffect(() => {
        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);


    useEffect(() => {

        if (UnusedQuotationByCompanyList) {
            let arr = [];
            UnusedQuotationByCompanyList.map((val) => { arr.push({ value: val.id, label: `${val.ship_quotation_no}`, trans_mode: val.transport_mode, trans_type: val.transport_type }) });
            setQuotationOptions(arr);
        } else {
            setQuotationOptions([]);
        }
    }, [UnusedQuotationByCompanyList]);


    useEffect(() => {
        if (formik.values.customer_id) {
            dispatch(getCompanyBranch(token, user_id, formik.values.customer_id));
            if (formik.values.is_direct_customer === false) {
                dispatch(getUnusedQuotationByCustomerList(token, user_id, formik.values.customer_id));
            } else {
                setQuotationOptions([]);
            }
        } else {
            setBranchOption([]);
            setQuotationOptions([]);
        }
    }, [formik.values.customer_id]);


    const [parentAgentDetail, setParentAgentDetail] = useState("");


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Job Order</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="is_direct_customer" className='form-label mb-0'>Direct Customer</label>
                                    <div className="icon-forms mb-3 mb-sm-0 col-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input
                                                    type="radio"
                                                    onChange={(e) => {
                                                        formik.resetForm();
                                                        formik.setFieldValue("is_direct_customer", true)
                                                        formik.setFieldValue("has_quotation", false)
                                                    }}
                                                    value={true}
                                                    id="is_direct_customer_yes"
                                                    className='me-1'
                                                    checked={formik.values.is_direct_customer === true}
                                                />
                                                <label htmlFor="is_direct_customer_yes">YES</label>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="radio"
                                                    onChange={(e) => {
                                                        formik.resetForm();
                                                        formik.setFieldValue("is_direct_customer", false);
                                                        formik.setFieldValue("has_quotation", true);
                                                    }}
                                                    value={false}
                                                    id="is_direct_customer_no"
                                                    className='me-1'
                                                    checked={formik.values.is_direct_customer === false}
                                                />
                                                <label htmlFor="is_direct_customer_no">NO</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            {
                                formik.values.is_direct_customer === true ?
                                    <>
                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Transport Mode
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="trans_mode"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.trans_mode}
                                                    >
                                                        <option value="">-</option>
                                                        <option value="Air">Air</option>
                                                        <option value="Sea">Sea</option>
                                                        {/* <option value="Road">Road</option>
                                                            <option value="Rail">Rail</option> */}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Transport Type
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="trans_type"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.trans_type}
                                                    >
                                                        <option value="">-</option>
                                                        <option value="Import">Import</option>
                                                        <option value="Export">Export</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2 '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Customer
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector'
                                                        placeholder="Select a customer"
                                                        options={customerOptions}
                                                        styles={customStyles}
                                                        name="customer_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('customer_id', option.value);
                                                            formik.setFieldValue('customer_branch_id', null);
                                                            if (option.parent_agent) {
                                                                setParentAgentDetail(option.parent_agent);
                                                            } else {
                                                                setParentAgentDetail("");
                                                            }
                                                        }}
                                                        value={formik.values.customer_id ? customerOptions.find(option => option.value == formik.values.customer_id || null) : null}
                                                        isLoading={loadingJobOrderApprovedCustomerList}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {parentAgentDetail && <div className="col-md-6 mt-2">
                                            <div className='ms-2 '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Sub Agent
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <input
                                                        type='text'
                                                        className='form-control form-control-sm'
                                                        disabled
                                                        value={parentAgentDetail}
                                                    />
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2 '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Branch
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector'
                                                        placeholder="Select a branch"
                                                        options={branchOption}
                                                        styles={customStyles}
                                                        name="customer_branch_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('customer_branch_id', option.value);
                                                        }}
                                                        value={formik.values.customer_branch_id ? branchOption.find(option => option.value == formik.values.customer_branch_id || null) : null}
                                                        isLoading={loadingJobOrderCompanyBranchList}
                                                    />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2 '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Job Owner
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector'
                                                        options={employeeOptions}
                                                        styles={customStyles}
                                                        placeholder="Select Job Owner"
                                                        name="job_owner_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('job_owner_id', option.value);
                                                        }}
                                                        value={formik.values.job_owner_id ? employeeOptions.find(option => option.value == formik.values.job_owner_id || null) : null}
                                                        isLoading={loadingJobOrderEmployeeList}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> :
                                    formik.values.is_direct_customer === false ?
                                        <>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2 '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Customer
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            placeholder="Select a customer"
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="customer_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('customer_id', option.value);
                                                                formik.setFieldValue('customer_branch_id', null);
                                                                formik.setFieldValue('quotation_id', "");
                                                                formik.setFieldValue('trans_mode', "");
                                                                formik.setFieldValue('trans_type', "");
                                                            }}
                                                            value={formik.values.customer_id ? customerOptions.find(option => option.value == formik.values.customer_id || null) : null}
                                                            isLoading={loadingJobOrderApprovedCustomerList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2 '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Branch
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            placeholder="Select a branch"
                                                            options={branchOption}
                                                            styles={customStyles}
                                                            name="customer_branch_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('customer_branch_id', option.value);
                                                            }}
                                                            value={formik.values.customer_branch_id ? branchOption.find(option => option.value == formik.values.customer_branch_id || null) : null}
                                                            isLoading={loadingJobOrderCompanyBranchList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2 '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Quotation
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            placeholder="Select a Quotation"
                                                            options={quotationOption}
                                                            styles={customStyles}
                                                            name="quotation_id"
                                                            onChange={option => {
                                                                formik.setFieldValue("trans_mode", "")
                                                                formik.setFieldValue("trans_type", "")
                                                                formik.setFieldValue('quotation_id', option.value);
                                                                formik.setFieldValue("trans_mode", option.trans_mode ? option.trans_mode : "")
                                                                formik.setFieldValue("trans_type", option.trans_type ? option.trans_type : "")
                                                            }}
                                                            value={formik.values.quotation_id ? quotationOption.find(option => option.value == formik.values.quotation_id || null) : null}
                                                            isLoading={loadingUnusedQuotationByCompanyList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Transport Mode
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="trans_mode"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.trans_mode}
                                                            disabled={true}
                                                        >
                                                            <option value="">-</option>
                                                            <option value="Air">Air</option>
                                                            <option value="Sea">Sea</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Transport Type
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="trans_type"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.trans_type}
                                                            disabled={true}
                                                        >
                                                            <option value="">-</option>
                                                            <option value="Import">Import</option>
                                                            <option value="Export">Export</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2 '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Job Owner
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={employeeOptions}
                                                            styles={customStyles}
                                                            placeholder="Select Job Owner"
                                                            name="job_owner_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('job_owner_id', option.value);
                                                            }}
                                                            value={formik.values.job_owner_id ? employeeOptions.find(option => option.value == formik.values.job_owner_id || null) : null}
                                                            isLoading={loadingJobOrderEmployeeList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        null
                            }

                        </div>
                        {(formik.values.is_direct_customer === true || formik.values.is_direct_customer == false) && <div className="row d-flex justify-content-end mt-2">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Save and Next"}
                                </button>
                            </div>
                        </div>}
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddJobOrderByQuotationOffcanvas2